import { PumpAsset } from 'src/types/assets';

type UsePumpStateProps = {
  asset?: PumpAsset;
  //websocketData?: WebsocketPumpData;
};

export const usePumpStateAndMode = ({ asset }: UsePumpStateProps) => {
  const stateFromRest = asset?.activeState;
  const modeFromRest = asset?.activeMode?.mode?.label;

  const activeState: string = stateFromRest?.state?.label ?? 'Undefined';
  const isOperational = stateFromRest?.state?.isOperational;

  const isRunning = Boolean(isOperational);

  return {
    activeState,
    isOperational,
    isRunning, // add websockets
    activeMode: modeFromRest, // add websockets
  };
};
